import validateEmail from './validate-email';
import validatePassword from './validate-password';
import validateTel from './validate-tel';

const validateForm = (formData = {}) => {
  let isValid = true;

  const validatedFormData = { ...formData };
  Object.keys(formData).forEach(key => {
    const { value: currentValue, isRequired, remove } = formData[key];
    if (remove) {
      return;
    }

    const normalizedValue = typeof currentValue === 'string' ? currentValue.trim() : currentValue;
    const isEmpty =
      normalizedValue === '' || normalizedValue === null || normalizedValue === undefined;

    if (isRequired && isEmpty) {
      isValid = false;
      validatedFormData[key].error = true;
      return;
    }

    if (!isRequired && isEmpty) {
      validatedFormData[key].error = false;
      return;
    }

    if (key === 'email' && !validateEmail(currentValue)) {
      isValid = false;
      validatedFormData[key].error = true;
    } else if (key === 'password' && !validatePassword(currentValue)) {
      isValid = false;
      validatedFormData[key].error = true;
    } else if (key === 'passwordConfirm' && formData.password.value !== currentValue) {
      isValid = false;
      validatedFormData[key].error = true;
    } else if (key === 'tel' && !validateTel(currentValue)) {
      isValid = false;
      validatedFormData[key].error = true;
    } else {
      validatedFormData[key].error = false;
    }
  });

  return [isValid, validatedFormData];
};

export default validateForm;
